<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h3>สถานะการแจ้ง Update ข้อมูลบัตรนายหน้า</h3>
                        <hr>
                        <h3 v-if="values.Status == 0"><span class="badge badge-info badge-pill p-2">แจ้งแจ้ง Update
                                ข้อมูลบัตรนายหน้าแล้ว
                                (เจ้าหน้าที่กำลังดำเนินการ)</span></h3>
                        <h3 v-if="values.Status == 1 && AMLExpiredIn <= 60"><span
                                class="badge badge-danger badge-pill p-2">ยังไม่แจ้ง Update ข้อมูลบัตรนายหน้า</span>
                        </h3>
                        <h3 v-if="values.Status == 1 && AMLExpiredIn > 60"><span
                                class="badge badge-success badge-pill p-2">Active</span></h3>
                        <h3 v-if="values.Status == 2">
                            <span class="badge badge-success badge-pill p-2">Reject</span>
                            <span class="text-danger ml-2 mt-4">{{ values.ApprovedReason }}</span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-show="!pageReady">
                        กำลังโหลดข้อมูล
                    </div>
                    <div class="card-body" v-show="pageReady">
                        <div v-if="!showForm">รหัสสมาชิกนี้มีรายชื่อใน AML แล้ว</div>
                        <form v-else action="" class="" @submit.prevent="validateForm" novalidate>

                            <div v-if="values.Status == 0">
                                <h3>เหตุผลการแก้ไข</h3>
                                <div class="row mt-3">
                                    <p class="px-4">
                                        {{ values.EditReason }}
                                    </p>
                                </div>
                                <hr>
                            </div>

                            <h3>เอกสาร</h3>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <FormUpload2 v-if="editAble" :values="Files"
                                        :FileCategories="FileCategories.filter(c => c.Id == 3)" @addFile="addFile" />
                                    <b-table v-if="Files.length > 0" class="table-sm" striped hover :fields="fileFields"
                                        :items="Files">
                                        <template v-slot:cell(Actions)="row">
                                            <router-link
                                                :to="{ name: 'openfile', query: { url: VUE_APP_OFFICEAPI_URL + '/api/file/downloadfile/' + row.item.RefId } }"
                                                v-if="!row.item.AddNew" class="btn btn-sm btn-secondary mr-1"
                                                target="_blank">
                                                ดู
                                            </router-link>
                                            <span v-if="editAble">
                                                <button type="button" v-if="row.item.AddNew"
                                                    class="btn btn-sm btn-danger"
                                                    @click="removeFile(row.index)">ลบ</button>
                                                <!-- <button type="button" v-else-if="row.item.Remove == 1"
                                                    class="btn btn-sm btn-warning"
                                                    @click="toggleRealFile(row.index, 0)">ยกเลิกลบ</button>
                                                <button type="button" v-else class="btn btn-sm btn-danger"
                                                    @click="toggleRealFile(row.index, 1)">ลบ</button> -->
                                            </span>
                                        </template>
                                    </b-table>
                                    <b-button type="submit" v-if="Files.filter(c => c.AddNew == 1).length > 0"
                                        variant="primary">
                                        <i class="fe-save mr-1"></i>
                                        บันทึกเพิ่อ แจ้ง Update ข้อมูลบัตรนายหน้า
                                    </b-button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>

import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'
// import FormAddressProvinceCompare from '@/components/FormAddressProvinceCompare.vue'
import FormUpload2 from '@/components/FormUpload2.vue'
// import FormInputCompare from '@/components/FormInputCompare.vue'

let self;
/**
 * Customers component
 */
export default {
    page: {
        title: 'Upload เอกสารสำหรับ Update ข้อมูลบัตรนายหน้า',
        meta: [{ name: 'description' }],
    },
    components: {
        Layout,
        PageHeader,
        // FormAddressProvinceCompare,
        FormUpload2,
        // FormInputCompare
    },
    data() {
        var yup = this.yup
        return {
            IsSubmit: false,
            title: 'Upload เอกสารสำหรับ Update ข้อมูลบัตรนายหน้า',
            items: [
                {
                    text: 'SKLife',
                    to: { name: 'home' }
                },
                {
                    text: 'Renew Member',
                    active: true,
                },
            ],
            admin: {},
            adminId: '',
            changePassword: false,
            pageReady: true,
            editAble: true,
            showForm: true,
            SameAddress: true,
            VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
            PrefixDatas: [],
            MaritalStatusDatas: [
                { id: 1, value: 'โสด' },
                { id: 2, value: 'หย่าร้าง' },
                { id: 3, value: 'หม้าย' },
                { id: 4, value: 'สมรส' },
            ],
            BankDatas: [],
            AdminDatas: [],
            OccupationDatas: [
                { id: 1, value: 'พนักงานบริษัท' },
                { id: 2, value: 'ธุรกิจส่วนตัว' },
                { id: 3, value: 'ค้าขาย' },
                { id: 4, value: 'ราชการ/รัฐวิสาหกิจ' },
                { id: 6, value: 'อื่นๆระบุ' },
            ],
            UnderSKLDatas: [
                { id: 1, value: 'ใช่' },
                { id: 2, value: 'ไม่ใช่' },
                { id: 3, value: 'ไม่มีสังกัด' },
            ],
            ApproveDatas: [
                { id: 1, value: 'ใช่' },
                { id: 2, value: 'ไม่ใช่' },
            ],
            CitizenTypeDatas: [
                { id: 1, value: 'บุคคลธรรมดา' },
                { id: 2, value: 'บุคคลจดทะเบียนภาษี/นิติบุคคล' },
            ],

            approveValues: {
                Id: "",
                Status: "1",
                ApprovedReason: "",
                ThisAdminId: this.$store.state.Admin.Id
            },
            fileFields: [
                {
                    key: 'CreatedAt', label: 'วันที่ Upload เอกสาร', sortDirection: 'desc',
                    formatter: (value, key, item) => {
                        return (value ? this.timeFormat(value) : 'เพิ่มใหม่')
                    }
                },
                {
                    key: 'Name', label: 'ชื่อ',
                    formatter: (value, key, item) => {
                        return item.Name
                    }
                },
                { key: 'Description', label: 'รายละเอียด' },
                {
                    key: 'FileCategoryId', label: 'ประเภท',
                    formatter: (value, key, item) => {
                        //console.log(this.FileCategories)
                        let found = this.FileCategories.find(element => element.Id == value);
                        return found.Name
                    }
                },
                { key: 'Actions', label: 'Actions' }

            ],
            Files: [],
            FileCategories: [],
            valuesCompare: {},
            showCompare: false,
            AMLExpiredIn: 0,
            values: [],
            pageReadOnly: false,
            errors: {
                Id: 0,
                RefId: "",
                RefFile: "",
                Level: "",
                SKAgentId: "",
                SKPrefixId: "",
                SKFirstname: "",
                SKLastname: "",
                AgentId: "",
                SKLAgentId: "",
                CitizenType: "",
                PrefixId: "",
                Firstname: "",
                Lastname: "",
                Birthdate: "",
                CitizenId: "",
                MaritalStatusID: "",
                SpouseFirstname: "",
                SpouseLastname: "",
                Phone: "",
                Line: "",
                Email: "",
                Address: "",
                HouseNumber: "",
                VillageNumber: "",
                Building: "",
                Floor: "",
                Alley: "",
                Road: "",
                SubDistrictId: "",
                SubDistrict: "",
                DistrictId: "",
                District: "",
                ProvinceId: "",
                Province: "",
                Zipcode: "",
                SameAddress: "",
                DeliveryAddress: "",
                DeliveryHouseNumber: "",
                DeliveryVillageNumber: "",
                DeliveryBuilding: "",
                DeliveryFloor: "",
                DeliveryAlley: "",
                DeliveryRoad: "",
                DeliverySubDistrictId: "",
                DeliverySubDistrict: "",
                DeliveryDistrictId: "",
                DeliveryDistrict: "",
                DeliveryProvinceId: "",
                DeliveryProvince: "",
                DeliveryZipcode: "",
                BankId: "",
                BankAccountId: "",
                BankBranch: "",
                ReserveBankId: "",
                ReserveBankAccountId: "",
                ReserveBankBranch: "",
                OccupationId: "",
                OccupationOther: "",
                BrokerCard: "",
                BrokerCardExpire: "",
                BrokerCardRenew: "",
                UnderSKL: "",
                Status: "",
                IsEdit: "",
                Active: "",
                EditReason: "",
                ByAdminId: "",
                CreatedBy: "",
            },
            FormSchema: yup.object().shape({
                SKAgentId: yup.string().nullable().required(),
                SKPrefixId: yup.string().nullable().required(),
                SKFirstname: yup.string().nullable().required(),
                SKLastname: yup.string().nullable().required(),
                AgentId: yup.string().nullable().required(),
                CitizenType: yup.string().required(),
                PrefixId: yup.string().nullable().required(),
                Firstname: yup.string().nullable().required(),
                Lastname: yup.string().nullable().required(),
                Birthdate: yup.string().nullable().required(),
                CitizenId: yup.string().nullable().required(),
                MaritalStatusID: yup.string().nullable().required(),
                SpouseFirstname: yup.string().nullable(),
                SpouseLastname: yup.string().nullable(),
                Phone: yup.string().nullable().required(),
                Line: yup.string().nullable(),
                Email: yup.string().nullable(),
                Address: yup.string().nullable().required(),
                HouseNumber: yup.string().nullable().required(),
                VillageNumber: yup.string().nullable(),
                Building: yup.string().nullable(),
                Floor: yup.string().nullable(),
                Alley: yup.string().nullable(),
                Road: yup.string().nullable(),
                SubDistrictId: yup.string().nullable().required(),
                DistrictId: yup.string().nullable().required(),
                ProvinceId: yup.string().nullable().required(),
                Zipcode: yup.string().nullable().required(),
                DeliveryAddress: yup.string().nullable(),
                DeliveryHouseNumber: yup.string().nullable(),
                DeliveryVillageNumber: yup.string().nullable(),
                DeliveryBuilding: yup.string().nullable(),
                DeliveryFloor: yup.string().nullable(),
                DeliveryAlley: yup.string().nullable(),
                DeliveryRoad: yup.string().nullable(),
                DeliverySubDistrictId: yup.string().nullable(),
                DeliveryDistrictId: yup.string().nullable(),
                DeliveryProvinceId: yup.string().nullable(),
                DeliveryZipcode: yup.string().nullable(),
                BankId: yup.string().nullable().required(),
                BankAccountId: yup.string().nullable().required(),
                BankBranch: yup.string().nullable().required(),
                ReserveBankId: yup.string().nullable(),
                ReserveBankAccountId: yup.string().nullable(),
                ReserveBankBranch: yup.string().nullable(),
                OccupationId: yup.string().nullable().required(),
                OccupationOther: yup.string().nullable(),
                BrokerCard: yup.string().nullable().required(),
                BrokerCardExpire: yup.string().nullable().required(),
                BrokerCardRenew: yup.string().nullable().required(),
                UnderSKL: yup.string().nullable().required(),
                EditReason: yup.string().nullable().required(),
                ByAdminId: yup.string().nullable(),
            }),
        }
    },
    watch: {
        Files: {
            handler: function () {
                console.log(this.Files);
            }
        }
    },
    async created() {
        self = this;
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        validateForm() {
            this.FormSchema
                .validate(this.values, { abortEarly: false })
                .then(() => {
                    this.sendData(this.values);
                })
                .catch(err => {
                    console.log(err)
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
        },
        validate(field) {
            this.FormSchema
                .validateAt(field, this.values)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
        },
        async loadData() {
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
            };

            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/file/getfilecategorybyappid?AppId=1', config)
                .then(function (res) {
                    if (res.status == 200) {
                        let SetDatas = res.data.map((item) => {
                            return {
                                Id: item.Id,
                                Name: item.Name
                            }
                        })
                        self.FileCategories = SetDatas;
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                });

            let curAgentId = '';
            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/agent/getagentbyrefid/' + self.$store.state.Admin.RefId, config)
                .then(function (res) {
                    if (res.status == 200) {
                        curAgentId = res.data.AgentId;
                        if (res.data.Status == 2 || res.data.Status == 3)
                            self.pageReadOnly = true;

                        self.values = res.data;
                        self.values.SKAgentId = 'AM' + res.data.AgentId;
                        self.values.SKLAgentId = 'AML' + res.data.AgentId;
                        self.values.Birthdate = self.$dayjs(res.data.Birthdate).format('YYYY-MM-DD');
                        self.values.BrokerCardExpire = self.$dayjs(res.data.BrokerCardExpire).format('YYYY-MM-DD');
                        self.values.ThisAdminId = self.$store.state.Admin.Id;

                        self.SameAddress = false;
                        if (res.data.DeliveryHouseNumber == "") {
                            self.SameAddress = true;
                        }

                        self.AMLExpiredIn = Math.floor(self.$dayjs(self.values.BrokerCardExpire).diff(self.$dayjs(), 'day', true));
                        self.values.EditReason = self.values.Status == 0 ? self.values.EditReason : '*** แจ้ง Update ข้อมูลบัตรนายหน้า โดย ' + self.values.AgentId + ' ***';
                        self.approveValues.Id = res.data.Id;

                        //if(self.values.Status == 0){
                        self.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/file/getfilebyapprowid?AppId=1&AppRowId=' + res.data.RefFile, config)
                            .then(function (res2) {
                                self.Files = res2.data;
                            });
                        //}

                    } else {
                        self.$swal('เกิดข้อผิดพลาด3');
                    }
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด4');
                });
        },
        sendData(values) {
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
            };
            this.IsSubmit = true;

            //add new
            if (values.Id != 0) {
                values.IsEdit = 1;
            } else {
                values.IsEdit = 0;
            }
            this.axios.put(process.env.VUE_APP_OFFICEAPI_URL + '/api/agent', values, config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.uploadFile(res.data.RefFile);
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                        self.IsSubmit = false;
                    }
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.IsSubmit = false;
                });
        },
        uploadFile(RefFile) {
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
            };
            let thisFiles = this.Files;
            let allPromises = [];
            let results = {
                form: {
                    success: 1,
                    all: 1,
                },
                addImage: {
                    success: 0,
                    all: 0,
                },
                removeImage: {
                    success: 0,
                    all: 0,
                },
            };
            thisFiles.forEach(file => {
                let valueFile = {
                    AppId: 1,
                    RefFile: RefFile,
                    Folder: "Agent/" + RefFile,
                    Files: file,
                    AgentId: self.values.AgentId
                }
                if (file.AddNew == 1) {
                    console.log('AddNew', file);
                    let urlFile = process.env.VUE_APP_OFFICEAPI_URL + '/api/file/uploadfile';
                    let promise = new Promise((resolve, reject) => {
                        self.axios.post(urlFile, valueFile, config)
                            .then(function (res) {
                                if (res.status == 200) {
                                    results.addImage.success += 1;
                                    results.addImage.all += 1;
                                    resolve();
                                } else {
                                    results.addImage.all += 1;
                                    resolve();
                                }
                            })
                            .catch(function (error) {
                                results.addImage.all += 1;
                                resolve();
                            });
                    });
                    allPromises.push(promise);
                } else if (file.Remove == 1) {
                    console.log('Remove', file);
                    let urlFile = process.env.VUE_APP_OFFICEAPI_URL + '/api/file/deletefile/' + file.RefId;
                    let promise = new Promise((resolve, reject) => {
                        self.axios.delete(urlFile, config)
                            .then(function (res) {
                                if (res.status == 200) {
                                    results.removeImage.success += 1;
                                    results.removeImage.all += 1;
                                    resolve();
                                } else {
                                    results.removeImage.all += 1;
                                    resolve();
                                }
                            })
                            .catch(function (error) {
                                results.removeImage.all += 1;
                                resolve();
                            });
                    });
                    allPromises.push(promise);
                }
            });

            Promise.all(allPromises).then(function (values) {
                self.IsSubmit = false;
                self.$swal.fire({
                    title: 'บันทึกข้อมูลสำเร็จ',
                    html:
                        'อัพโหลดฟอร์มสำเร็จ ' + results.form.success + '/' + results.form.all + '<br>' +
                        (results.addImage.all > 0 ? 'อัพโหลดไฟล์สำเร็จ ' + results.addImage.success + '/' + results.addImage.all + '<br>' : '') +
                        (results.removeImage.all > 0 ? 'ลบไฟล์สำเร็จ ' + results.removeImage.success + '/' + results.removeImage.all + '<br>' : ''),
                    showCancelButton: false,
                    confirmButtonText: 'ตกลง',
                }).then((result) => {
                    self.loadData();
                })
            });
        },
        approveData() {
            this.IsSubmit = true;
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
            };
            this.axios.put(process.env.VUE_APP_OFFICEAPI_URL + '/api/agent/approve', this.approveValues, config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.$swal.fire({
                            title: (self.approveValues.Status == '1' ? 'ยืนยันข้อมูลสำเร็จ' : 'ยกเลิกข้อมูลสำเร็จ'),
                            showCancelButton: false,
                            confirmButtonText: 'ตกลง',
                        }).then((result) => {
                            self.$router.push({ name: 'agent-list' });
                        })
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.IsSubmit = false;
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.IsSubmit = false;
                });
        },
        addFile(returnFiles) {
            this.Files = returnFiles.concat(this.Files);
        },
        removeFile(index) {
            this.Files.splice(index, 1);
        },
        toggleRealFile(index, Remove) {
            let newFile = this.Files[index];
            newFile.Remove = Remove;
            this.$set(this.Files, index, newFile);
        },
        showAdminName() {
            let result = this.AdminDatas.find((admin) => {
                return admin.code == self.values.ByAdminId
            })
            if (result) {
                return result.label;
            }
        },
        showEditName() {
            let result = this.AdminDatas.find((admin) => {
                return admin.code == self.values.CreatedBy
            })
            if (result) {
                return result.label;
            }
        },
        showApproveDetail() {
            let result = this.AdminDatas.find((admin) => {
                return admin.code == self.values.ApprovedBy
            })
            if (result) {
                let msgStatus = `${self.values.Status === 1 ? 'ผ่านการตรวจสอบ' : 'ไม่ผ่านการตรวจสอบ'}`;
                let msgApprReason = ' - ';
                if (self.values.ApprovedReason)
                    msgApprReason = self.values.ApprovedReason;

                return `${msgStatus}, เหตุผล: ${msgApprReason}, โดย: ${result.label}`;
                //return `${msgStatus}<br>เหตุผล: ${self.values.ApprovedReason}<br>โดย: ${result.label}`;
            }
        },
        editEnable() {
            this.editAble = !this.editAble
            if (!this.values.ByAdminId) {
                this.values.ByAdminId = parseInt(this.$store.state.Admin.Id);
            }
        },

        onClickShowHist() {
            this.$bvModal.show('bv-modal-hist');
        },

    },
}
</script>
